import { styledComponent, Paper } from '@hermes/web-components'

export const ModalPaper = styledComponent(Paper)(() => ({
  borderRadius: '16px',
  width: '100%',
  margin: '16px',
  padding: '16px'
}))

export const ContainerForForm = styledComponent('div')(() => ({
  '& > iframe': {
    minHeight: '562px'
  }
}))
